import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockStandart = ({id, errorResponse}) => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/'+id+'Request.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/'+id+'Response.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/'+id+'Request.xml'} title={t('Пример запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/'+id+'Response.xml'} title={t('Пример успешного ответа')}/>

				{Number(errorResponse) > 0 && <Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/'+id+(errorResponse === 1 ? 'Response' : '')+'Error.xml'} title={t('Пример ответа с ошибкой')}/>}

			</Container>
		</>
	);
};

export default ExmapleBlockStandart;